"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowPlaceholders = exports.GridPlaceholders = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _Column = require("./Column");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RowPlaceholders = _ref => {
  var amount = _ref.amount,
    height = _ref.height,
    numColumns = _ref.numColumns;
  var columns = Array(numColumns).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_Column.TableData, {
    key: index,
    alignment: 'center'
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    width: '100%',
    height: height
  })));
  var rows = Array(amount).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement("tr", {
    key: index
  }, columns));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, rows);
};
exports.RowPlaceholders = RowPlaceholders;
var GridPlaceholders = _ref2 => {
  var amount = _ref2.amount;
  var placeholders = Array(amount).fill(null).map((i, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, i));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, placeholders);
};
exports.GridPlaceholders = GridPlaceholders;
//# sourceMappingURL=Placeholder.js.map